import { render, staticRenderFns } from "./chinaTopics.vue?vue&type=template&id=1a426a2b&scoped=true"
import script from "./chinaTopics.vue?vue&type=script&lang=js"
export * from "./chinaTopics.vue?vue&type=script&lang=js"
import style0 from "./chinaTopics.vue?vue&type=style&index=0&id=1a426a2b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a426a2b",
  null
  
)

export default component.exports